import React from 'react';
import { useTranslation } from '../../../shared/i18n';
import gameBoxGif from '../../../assets/conectados/title-box.gif';
import * as S from './AnimatedTitle.styles';

function AnimatedTitle() {
  const t = useTranslation();
  
  return (
    <S.TitleContainer>
      <S.GameBoxImage 
        src={gameBoxGif} 
        alt={t('conectados.title')}
      />
    </S.TitleContainer>
  );
}

export default AnimatedTitle;

